"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlanes = void 0;
var getSrcPlane_1 = require("./getSrcPlane");
var getDestPlane_1 = require("./getDestPlane");
var translate2d_1 = require("../../common/translate2d");
var inferMarks_1 = require("./inferMarks");
var getFixMarks_1 = require("./getFixMarks");
var getPlanes = function (config) {
    var srcPlane = getSrcPlane_1.getSrcPlane(config);
    var destPlane = getDestPlane_1.getDestPlane(config);
    var dataPointGroup = [];
    var yMax = config.yAxis.fixMaxExtend || config.yAxis.fixMax;
    config.values.map(function (it) {
        var value = it;
        var series = value.series;
        if (config.type === 'range') {
            var dataPoints = series.map(function (it, i) { return [
                translate2d_1.translate2d([i, it[0]], srcPlane, destPlane),
                translate2d_1.translate2d([i, it[1]], srcPlane, destPlane)
            ]; });
            dataPointGroup.push(dataPoints);
        }
        else {
            var dataPoints = series.map(function (it, i) { return translate2d_1.translate2d([i, it], srcPlane, destPlane); });
            dataPointGroup.push(dataPoints);
        }
    });
    var valuesHasDecimals = (config.type === 'range' ? config.values.map(function (it) { return it.series.map(function (it2) { return it2.reduce(function (acc, it3) { return acc + it3; }, 0); }); }) : config.values.map(function (it) { return it.series; })).flatMap(function (it) { return it; }).map(function (it) { return Math.round(it) !== it; }).reduce(function (acc, it) { return acc || it; }, false);
    var yAxisInferredMarks = inferMarks_1.inferMarks(srcPlane, destPlane, config.yAxis.lineDensity, !valuesHasDecimals);
    var yAxisFixMarks = (yMax && config.yAxis.fixStep) ? getFixMarks_1.getFixMarks(srcPlane, destPlane, yMax, config.yAxis.fixStep) : [];
    var yAxisMarks = yAxisFixMarks.length ? yAxisFixMarks : yAxisInferredMarks;
    return {
        dataPointGroup: dataPointGroup,
        yAxisMarks: yAxisMarks,
        destPlane: destPlane
    };
};
exports.getPlanes = getPlanes;
